import { render, staticRenderFns } from "./credit-assignment-record.vue?vue&type=template&id=161d2dc7"
import script from "./credit-assignment-record.vue?vue&type=script&lang=js"
export * from "./credit-assignment-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports